/* prompt
make a array of arrays of 5 with 7 entries, each are dates,
the current date should sit in the 3rd array,
2 week before and 2 weeks after the current date. the week should start on a monday.
monday of course is the 1st position in each of the 5 arrays.

*/

export function generateCalendarWeeks(centerDate) {
  const weeks = []
  // const totalDaysToShow = 35 // 5 arrays * 7 entries
  const today = new Date(centerDate) // Start with a copy of the current date

  // 1. Find the Monday of the week that is 2 weeks prior to the current date's week.
  // JavaScript's getDay() returns 0 for Sunday, 1 for Monday, ..., 6 for Saturday.
  let dayOfWeek = today.getDay()
  // Adjust dayOfWeek so that Sunday (0) becomes 7, making Monday (1) the start of the week
  if (dayOfWeek === 0) dayOfWeek = 7

  // Calculate how many days to go back to find the most recent Monday (of this week)
  const daysSinceMonday = dayOfWeek - 1

  // Go back 2 full weeks (14 days) and then back to the Monday of that starting week
  const startDate = new Date(today)
  startDate.setDate(today.getDate() - daysSinceMonday - 7)
  startDate.setHours(0, 0, 0, 0) // Set time to the beginning of the day for consistency

  // 2. Loop to generate the 5 arrays of 7 dates
  let currentDay = new Date(startDate)
  for (let i = 0; i < 5; i++) {
    // Loop for 5 weeks
    const week = []
    for (let j = 0; j < 7; j++) {
      // Loop for 7 days in a week

      week.push(
        //@ts-ignore
        new Date(currentDay)
      ) // Push a copy of the current date
      // Increment the date by one day. setDate handles month/year rollovers automatically.
      currentDay.setDate(currentDay.getDate() + 1)
    }
    weeks.push(
      //@ts-ignore
      week
    )
  }

  return weeks
}
